import { devConfig } from "./appConfig.js";

/**
 * devConfig を document.documentElement の CSS 変数に流し込む（CRT 調整用）
 * @param {HTMLElement} [root]
 */
export function applyDevConfig(root = document.documentElement) {
  const crt = devConfig.crt;
  const v = crt.vignette;
  const s = crt.scanlines;
  const n = crt.noiseLayer;
  const f = crt.flicker;
  const g = crt.glitch;
  const r = root.style;

  r.setProperty("--crt-vignette-ellipse-w", `${v.ellipseWPercent}%`);
  r.setProperty("--crt-vignette-ellipse-h", `${v.ellipseHPercent}%`);
  r.setProperty("--crt-vignette-center-x", `${v.centerXPercent}%`);
  r.setProperty("--crt-vignette-center-y", `${v.centerYPercent}%`);
  r.setProperty("--crt-vignette-inner-stop", `${v.innerStopPercent}%`);
  r.setProperty("--crt-vignette-edge-opacity", String(v.edgeOpacity));
  r.setProperty("--crt-vignette-inset-blur", `${v.insetBlurPx}px`);
  r.setProperty("--crt-vignette-inset-shadow-opacity", String(v.insetShadowOpacity));

  r.setProperty("--crt-scanlines-opacity", String(s.layerOpacity));
  r.setProperty("--crt-scanline-dark", String(s.lineDarken));
  r.setProperty("--crt-scanline-line-h", `${s.lineHeightPx}px`);
  r.setProperty("--crt-scanline-gap", `${s.gapBelowLinePx}px`);

  r.setProperty("--crt-noise-opacity", String(n.opacity));

  r.setProperty("--crt-flicker-overlay", String(f.overlayDarken));
  r.setProperty("--crt-flicker-duration", `${f.durationSec}s`);
  r.setProperty("--crt-flicker-k0", String(f.key0Opacity));
  r.setProperty("--crt-flicker-k50", String(f.key50Opacity));
  r.setProperty("--crt-flicker-k100", String(f.key100Opacity));
  r.setProperty("--crt-flicker-reduced-opacity", String(f.reducedMotionOpacity));

  const ga = g.stripA;
  r.setProperty("--crt-glitch-a-dur", `${ga.durationSec}s`);
  r.setProperty("--crt-glitch-a-top", `${ga.topPercent}%`);
  r.setProperty("--crt-glitch-a-white", String(ga.whiteA));
  r.setProperty("--crt-glitch-a-green", String(ga.greenA));
  r.setProperty("--crt-glitch-a-k95", String(ga.key95));
  r.setProperty("--crt-glitch-a-k96", String(ga.key96));
  r.setProperty("--crt-glitch-a-tx95", `${ga.tx95Percent}%`);
  r.setProperty("--crt-glitch-a-tx96", `${ga.tx96Percent}%`);

  const gb = g.stripB;
  r.setProperty("--crt-glitch-b-dur", `${gb.durationSec}s`);
  r.setProperty("--crt-glitch-b-top", `${gb.topPercent}%`);
  r.setProperty("--crt-glitch-b-red", String(gb.redA));
  r.setProperty("--crt-glitch-b-white", String(gb.whiteA));
  r.setProperty("--crt-glitch-b-k97", String(gb.key97));
  r.setProperty("--crt-glitch-b-k98", String(gb.key98));
  r.setProperty("--crt-glitch-b-tx97", `${gb.tx97Percent}%`);
  r.setProperty("--crt-glitch-b-tx98", `${gb.tx98Percent}%`);
  r.setProperty("--crt-glitch-b-sk97", `${gb.skew97Deg}deg`);
  r.setProperty("--crt-glitch-b-sk98", `${gb.skew98Deg}deg`);

  const gc = g.stripC;
  r.setProperty("--crt-glitch-c-dur", `${gc.durationSec}s`);
  r.setProperty("--crt-glitch-c-top", `${gc.topPercent}%`);
  r.setProperty("--crt-glitch-c-blue", String(gc.blueA));
  r.setProperty("--crt-glitch-c-white", String(gc.whiteA));
  r.setProperty("--crt-glitch-c-k96", String(gc.key96));
  r.setProperty("--crt-glitch-c-k97", String(gc.key97));
  r.setProperty("--crt-glitch-c-tx96", `${gc.tx96Percent}%`);
  r.setProperty("--crt-glitch-c-tx97", `${gc.tx97Percent}%`);
}
